<script setup lang="ts">
    import { cn } from "@/utils";
    import { HTMLAttributes } from "vue";
    import { useCurrentSite } from "@/vue/composables/useCurrentSite";

    const props = defineProps<{
        class?: HTMLAttributes['class'],
        variant?: 'gray',
    }>()
    const modelValue = defineModel<string|number>();

    const currentSite = useCurrentSite();
</script>

<template>
    <input :class="cn({
        [`${'peer h-10 w-full px-4 py-2 placeholder-shown:pr-10 md:text-body-sm appearance-none bg-white border-neutral-300 border rounded-none outline-none text-neutral-900 placeholder-neutral-500'}`]: currentSite.isAS(),
        [`${variant === 'gray'
            ? 'peer h-[2.875rem] w-full rounded-full duration-300 ease-out md:text-body-sm pl-6 py-2 pr-10 appearance-none outline-none bg-neutral-100 text-neutral-900 placeholder-neutral-500 disabled:bg-neutral-200'
            : 'peer h-10 w-full rounded-lg px-4 py-2 placeholder-shown:pr-10 md:text-body-sm appearance-none bg-white border-neutral-300 border outline-none text-neutral-900 placeholder-neutral-500'
        }`]: currentSite.isCU(),
    }, props.class)"
        v-model="modelValue"
    >
</template>
